const NormalText=({text,className})=>
{
    return(
        <p className={`sm:text-[14px] lg:text-[18px] font-[300] sm:leading-[20px] lg:leading-[35px] text-center text-[#656565] ${className}`}>{text}</p>
    )
}
export default NormalText